<div class="aca-sidenav">
  <app-sidenav-header (toggleNavBar)="toggleClick()" />

  <div class="aca-sidenav__section">
    <div *ngFor="let group of groups; trackBy: trackByGroupId" class="aca-sidenav__section__actions">
      <nav
        [attr.aria-label]="item.title | translate"
        class="aca-sidenav__section__actions__item"
        *ngFor="let item of group.items; trackBy: trackByLinkId"
      >
        <ng-container *ngIf="!item.component">
          <app-expand-menu [item]="item" />
        </ng-container>
        <ng-container *ngIf="item.component">
          <adf-dynamic-component [data]="{ item: item, state: 'expanded' }" [id]="item.component" />
        </ng-container>
      </nav>
    </div>
  </div>
</div>
